export default "__VITE_ASSET__BtwMO8hQ__"